import { network } from 'services/network';
import { useQuery } from 'react-query';
import { QueryKeys } from 'api/queryKeys';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import moment from 'moment-timezone';

const queryFn = (params: QueryParams) => {
    return network.post('api/bo/highLevelProgram', params).then((response) => response.data);
};

export const useQueryHighLevelProgram = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['highLevelProgram', params],
        queryFn: () => queryFn(params),
        enabled: params.id.length > 0 && params.id.filter((item) => item).length > 0,
        select: (data) => {
            const nowDate = moment(data.nowDate || '201010').toDate();
            return {
                data: data.wbs,
                info: data.info,
                nowDate: nowDate,
            };
        },
    });
};

interface QueryParams {
    id: string[];
    filter: { filters: IFilter[] | undefined };
}

interface QueryFnResponse {
    info: IToolTip;
    nowDate: Date;
    wbs: {
        actualEndDate: null;
        actualStartDate: number;
        color: string;
        description: string;
        'duration%Complete': number;
        level: number;
        plannedEndDate: number;
        plannedStartDate: number;
        taskCode: string;
    }[];
}

export type QueryResponse = {
    info: IToolTip;
    nowDate: Date;
    data: {
        actualEndDate: null;
        actualStartDate: number;
        color: string;
        description: string;
        'duration%Complete': number;
        level: number;
        plannedEndDate: number;
        plannedStartDate: number;
        taskCode: string;
    }[];
};
